import { Box, Typography } from '@mui/material'
import { Chip, Tooltip } from 'components'
import strings from 'strings'
import styles from './activeUnits.module.scss'
import { formatDateMMDDYYYY } from 'tools/helper'

const s = strings.TABLE_DEFAULTS

export const getActiveUnitsColumns = (t: any, createPerformanceChip: any) => [
  {
    field: 'vin',
    flex: 1,
    minWidth: 180,
    headerClassName: 'columnGroupTitle centered',
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.VIN}
      </Typography>
    ),
    renderCell: (params: any) => {
      return (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="body2"
            fontFamily={'monospace'}
            fontSize={'0.8rem'}
          >
            {params?.value ? params.value : s.DASH_VALUE}
          </Typography>
          {params?.row?.uniqueVin === false && (
            <Chip
              label={t.DUP_CHIP}
              color="primary"
              size="small"
              variant="filled"
              sx={{
                height: '14px',
                fontSize: '0.6rem',
                lineHeight: 1,
                color: '#fff',
                ml: 0.5,
                '& .MuiChip-label': {
                  padding: '0 4px',
                },
              }}
            />
          )}
        </Box>
      )
    },
  },
  {
    field: 'year',
    width: 80,
    headerClassName: 'columnGroupTitle centered',
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.YEAR}
      </Typography>
    ),
    renderCell: (params: any) => (
      <div className={styles.cellContainer}>
        {params?.value ? params.value : s.DASH_VALUE}
      </div>
    ),
  },
  {
    field: 'make',
    minWidth: 110,
    flex: 1,
    headerClassName: 'columnGroupTitle centered',
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        alignContent={'center'}
        textAlign={'center'}
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.MAKE}
      </Typography>
    ),
    renderCell: (params: any) => (
      <div className={styles.cellContainer}>
        {params?.value ? params.value : s.DASH_VALUE}
      </div>
    ),
  },
  {
    field: 'garagingZipCode',
    flex: 0.8,
    minWidth: 100,
    renderCell: (params: any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params?.value != null ? params.value : s.DASH_VALUE}
      </Typography>
    ),
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.GARAGING_ZIPCODE}
      </Typography>
    ),
  },
  {
    field: 'totalMiles',
    minWidth: 110,
    flex: 0.9,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.TOTAL_MILES}
      </Typography>
    ),
    renderCell: (params: any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params?.value ? Math.round(params.value).toLocaleString() : s.DASH_VALUE}
      </Typography>
    ),
  },
  {
    field: 'totalActiveDays',
    minWidth: 100,
    flex: 0.8,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.ACTIVE_DAYS}
      </Typography>
    ),
    renderCell: (params: any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params?.value ? Math.round(params.value).toLocaleString() : s.DASH_VALUE}
      </Typography>
    ),
  },
  {
    field: 'avgMilesDays',
    flex: 0.9,
    minWidth: 110,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.AVG_MILES_DAY}
      </Typography>
    ),
    renderCell: (params: any) => (
      <Typography
        height={'inherit'}
        variant={'body2'}
        alignContent={'center'}
        textAlign={'center'}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {params?.value ? Math.round(params.value).toLocaleString() : s.DASH_VALUE}
      </Typography>
    ),
  },
  {
    field: 'safetyEventsCount',
    flex: 0.7,
    minWidth: 90,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.SAFETY_EVENTS}
      </Typography>
    ),
    renderCell: (params: any) => (
      <div className={styles.cellContainer}>
        {createPerformanceChip(params.value)}
      </div>
    ),
  },
  {
    field: 'timeSpeedingPercentage',
    flex: 0.9,
    minWidth: 110,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.TIME_SPEEDING}
      </Typography>
    ),
    renderCell: (params: any) => (
      <div className={styles.cellContainer}>
        {createPerformanceChip(
          params.value && `${params.value?.toFixed(2)}%`,
          params.value > 10
        )}
      </div>
    ),
  },
  {
    field: 'latestScore',
    flex: 0.8,
    minWidth: 100,
    renderCell: (params: any) => {
      let tooltipText = t.NO_UPDATE_DATE
      if (params?.row?.latestScoreDate) {
        tooltipText = `${t.UPDATED_ON}${formatDateMMDDYYYY(
          params.row.latestScoreDate
        )}`
      }
      return (
        <div className={styles.cellContainer}>
          <Tooltip title={tooltipText}>
            <span>
              {params?.value ? (
                createPerformanceChip(
                  params.value.toFixed(2),
                  params.value < 75
                )
              ) : (
                <span>{s.NA}</span>
              )}
            </span>
          </Tooltip>
        </div>
      )
    },
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.CURRENT_RISK_SCORE}
      </Typography>
    ),
  },
  {
    field: 'previousScore',
    flex: 0.8,
    minWidth: 100,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.LAST_MONTH_SCORE}
      </Typography>
    ),
    renderCell: (params: any) => {
      let tooltipText = t.NO_UPDATE_DATE
      if (params?.row?.previousScoreDate)  {
        tooltipText = `${t.UPDATED_ON}${formatDateMMDDYYYY(
          params.row.previousScoreDate
        )}`
      }
      return (
        <Tooltip title={tooltipText}>
          <div className={styles.cellContainer}>
            <span style={{ color: '#616161' }}>
              {params?.value != null ? params.value.toFixed(2) : s.NA}
            </span>
          </div>
        </Tooltip>
      )
    },
  },
  {
    field: 'scoreDifference',
    flex: 0.8,
    minWidth: 100,
    renderHeader: () => (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          textAlign: 'center',
          lineHeight: 1.2,
          fontWeight: 'bold',
          color: '#000000',
        }}
      >
        {t.SCORE_CHANGE}
      </Typography>
    ),
    renderCell: (params: any) => {
      if(params?.row?.previousScore === null || ! params?.row?.latestScore ) {
        return(
          <div className={styles.cellContainer}>
            <span style={{ color: '#616161' }}>{s.NA}</span>
          </div>
        )
      }
      else {
      return(
      
      <div className={styles.cellContainer}>
        {createPerformanceChip(
          params?.value &&
            `${params.value > 0 ? '+' : ''}${params.value?.toFixed(2)}`,
          params.value < 0
        )}
      </div>
    )}},
  },
]
